module.exports = __webpack_public_path__ + "static/media/retail.355effbe.jpg";